export const DOCUMENTTEXTTYPE_NAME_TITLE = 'Title';
export const DOCUMENTTEXTTYPE_NAME_CONDITIONS = 'Conditions';
export const DOCUMENTTEXTTYPE_NAME_CONTRACTDETAILS = 'ContractDetails';
export const DOCUMENTTEXTTYPE_NAME_SIGNATURES = 'Handtekeningen';
export const DOCUMENTTEXTTYPE_CODE_APPR_BOX_BRUNO_WITH_SIGNATURE = 'MHANDTBRUNOM';
export const DOCUMENTTEXTTYPE_CODE_APPR_BOX_BRUNO_WITHOUT_SIGNATURE = 'ZHANDTBRUNOM';
export const DOCUMENTTEXTTYPE_CODE_APPR_BOX_FREDERIK_WITH_SIGNATURE = 'MHANDTFREDERIKD';
export const DOCUMENTTEXTTYPE_CODE_APPR_BOX_FREDERIK_WITHOUT_SIGNATURE = 'ZHANDTFREDERIKD';